import React from 'react'
import styled from '@emotion/styled'

const GoodFullDescriptionRoot = styled.div`
  font-size: 15px;
  color: #444;

  b, strong {
    color: #000;
    font-weight: 500;
  }
  
  a {
    color: #2d9831;
  }
  
  h1, h2, h3, h4, h5, h6 {
    color: #ec2323;
    font: 17px/1.4 Merriweather, serif;
    font-weight: 400;
  }
`

const GoodFullDescription = ({
  good
}) => {
  return <GoodFullDescriptionRoot dangerouslySetInnerHTML={{__html: good.fullDescription}}/>
}

export default GoodFullDescription
